export const purchaseOrderNoteTypes = [
  {
    label: 'Provider',
    value: '1',
  },
  {
    label: 'Internal',
    value: '2',
  },
];
